@if (isValidText(promotionalTexts[0])) {
<div class="displayL text-center marginBottom-s marginTop-xl">
  <span class="featured-heading--negative">{{ promotionalTexts[0] | translate}}</span>
</div>

} @if (isValidText(promotionalTexts[1])) {
<div class="text-center marginBottom-s displayS">
  <span class="featured-heading--negative">{{ promotionalTexts[1] | translate }}</span>
</div>

} @if (isValidText(promotionalTexts[2])) {
<div class="text-center marginBottom-s displayS">
  <span class="featured-heading--negative">{{ promotionalTexts[2] | translate}}</span>
</div>
}
